import type { EntregaPdfDocument } from '../../domain/EntregaPdfModel.ts';
import type { EntregaPdfPort } from '../../domain/ports/EntregaPdfPort.ts';
import { loadEntregaPdfTemplateBytes } from '@src/modules/platform/pdf/pdfTemplateSources.ts';
import { renderEntregaPdfFromTemplate } from './entregaPdfTemplateRenderer.ts';

export class BrowserEntregaPdfAdapter implements EntregaPdfPort {
  async generate(model: EntregaPdfDocument): Promise<Blob> {
    const templateBytes = await loadEntregaPdfTemplateBytes();
    const pdfBytes = await renderEntregaPdfFromTemplate(templateBytes, model);
    return new Blob([pdfBytes], { type: 'application/pdf' });
  }
}
